import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-edit-grid-command",
    templateUrl: "./edit-grid-command.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditGridCommandComponent {

}
